package com.vizio.redwolf.auth.model


/**
 * Update Account Request with birthdate and gender
 * Mobile will pass in null for birthdate and gender until adding in this functionality
 * After adding in the functionality, mobile MUST pass in a value for birthdate and gender at all times
 * as it is a required field
 */
data class UpdateUserDetailsRequestInfo(
    val accessToken: String,
    val firstName: String?,
    val lastName: String?,
    val phoneNumber: String?,
    val postalCode: String?,
    val birthDate: String? = null,
    val gender: String? = null
)